namespace TabAurous.Administration {
    export interface SequenceDetailsForm {
        SequenceId: Serenity.IntegerEditor;
        DepartmentId: Serenity.IntegerEditor;
        ProcessId: Serenity.IntegerEditor;
        Priority: Serenity.IntegerEditor;
    }

    export class SequenceDetailsForm extends Serenity.PrefixedContext {
        static formKey = 'Administration.SequenceDetails';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!SequenceDetailsForm.init)  {
                SequenceDetailsForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;

                Q.initFormType(SequenceDetailsForm, [
                    'SequenceId', w0,
                    'DepartmentId', w0,
                    'ProcessId', w0,
                    'Priority', w0
                ]);
            }
        }
    }
}
